import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Auth.css';
import { register } from '../api/auth';

const PHONE_REGEX = /^1\d{10}$/;

function RegisterPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    if (!PHONE_REGEX.test(phone)) {
      setError('请输入正确的手机号码');
      return;
    }
    if (!password || password.length < 6) {
      setError('密码至少6位字符');
      return;
    }
    if (password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }

    setLoading(true);
    try {
      // 调用后端注册API
      const response = await register(phone, password);
      
      // 存储JWT token
      localStorage.setItem('lda_auth_token', response.access_token);
      
      setSuccess('注册成功，正在跳转...');
      setTimeout(() => navigate('/'), 300);
    } catch (error) {
      console.error('注册失败:', error);
      if (error.response?.data?.detail) {
        setError(error.response.data.detail);
      } else {
        setError('注册失败，请稍后重试');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <section className="auth-hero">
          <div>
            <div className="logo">
              <i className="fas fa-robot"></i>
              <span>湾小通</span>
            </div>
            <h1 className="auth-hero-title">创建新账户</h1>
            <p className="auth-hero-subtitle">加入我们，开始您的文本分析之旅</p>
          </div>
          <div className="auth-hero-points">
            <span><span className="auth-dot"></span>快速注册</span>
            <span><span className="auth-dot"></span>免费使用所有功能</span>
            <span><span className="auth-dot"></span>体验 LDA 主题建模</span>
          </div>
        </section>

        <section className="auth-card">
          <div>
            <span className="auth-badge">注册</span>
            <h2 className="auth-title">新用户注册</h2>
            <p className="auth-subtitle">填写以下信息完成注册</p>
          </div>

          {error && <div className="auth-alert auth-alert-error">{error}</div>}
          {success && <div className="auth-alert auth-alert-success">{success}</div>}

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-field">
              手机号
              <input
                className="auth-input"
                type="tel"
                placeholder="请输入11位手机号"
                value={phone}
                onChange={(event) => setPhone(event.target.value.trim())}
                autoComplete="tel"
              />
            </label>
            <label className="auth-field">
              密码
              <input
                className="auth-input"
                type="password"
                placeholder="至少6位字符"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="new-password"
              />
            </label>
            <label className="auth-field">
              确认密码
              <input
                className="auth-input"
                type="password"
                placeholder="请再次输入密码"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                autoComplete="new-password"
              />
            </label>
            <button className="auth-button" type="submit" disabled={loading}>
              {loading ? '注册中...' : '注册'}
            </button>
          </form>

          <div className="auth-footer">
            <span>已有账号？</span>
            <Link className="auth-link" to="/login">立即登录</Link>
          </div>
          <div className="auth-note">注册即表示您同意我们的服务条款</div>
        </section>
      </div>
    </div>
  );
}

export default RegisterPage;
